import React, { useMemo, useState } from 'react';
import { translate } from '@utils/i18n';
import { TabView } from '@ui/molecules/TabView/TabView';
import { Button } from '@ui';
import { sprinklerProjectionReportAnalyticReportsPath } from '@routes';
import SprinklerSamplingTable from '../SprinklerSampling/SprinklerSamplingTable';
import KitOrderTable from '../SprinklerSampling/components/KitOrderTable';
import ContactDyneModal from '../SprinklerSampling/components/ContactDyneModal';
import KitOrderForm from '../SprinklerSampling/components/KitOrderForm';
import './SprinklerHeadSamplingPageStyles.scss';
const NAMESPACE = 'analytic_reports.sprinkler_projection_report';
export default function SprinklerHeadSamplingPage() {
    const [isContactDyneOpen, setIsContactDyneOpen] = useState(false);
    const [isKitOrderOpen, setIsKitOrderOpen] = useState(false);
    const tabs = useMemo(() => [
        {
            id: 'sample-submissions',
            label: translate('tabs.sample_submissions', { namespace: NAMESPACE }),
            content: React.createElement(SprinklerSamplingTable, { showActions: false })
        },
        {
            id: 'kit-orders',
            label: translate('tabs.kit_orders', { namespace: NAMESPACE }),
            content: React.createElement(KitOrderTable, null)
        }
    ], []);
    return (React.createElement("div", { className: "workspace__body" },
        React.createElement("div", { className: "workspace__major--listing sprinkler-head-sampling-page" },
            React.createElement("div", { className: "workspace__header" },
                React.createElement("div", { className: "header__main" },
                    React.createElement("h1", { className: "workspace__title" }, translate('sprinkler_head_sampling', { namespace: NAMESPACE })))),
            React.createElement("p", { className: "subtitle" }, translate('intro', { namespace: NAMESPACE })),
            React.createElement("div", { className: "qmb-content-actions" },
                React.createElement("div", { className: "content-actions__group" },
                    React.createElement(Button, { onClick: () => setIsContactDyneOpen(true) },
                        React.createElement("i", { className: "fa-light fa-message-lines" }),
                        translate('contact_dyne', { namespace: NAMESPACE }))),
                React.createElement("div", { className: "content-actions__group--separate" },
                    React.createElement(Button, { onClick: () => setIsKitOrderOpen(true) },
                        React.createElement("i", { className: "fa-light fa-box-taped" }),
                        translate('order_kits', { namespace: NAMESPACE }))),
                React.createElement("div", { className: "content-actions__group--separate" },
                    React.createElement("a", { className: "qmb-control", href: sprinklerProjectionReportAnalyticReportsPath() },
                        React.createElement("i", { className: "fa-light fa-chart-line" }),
                        translate('view_projection_report', { namespace: NAMESPACE })))),
            React.createElement("hr", { className: "workspace__split" }),
            React.createElement(TabView, { tabs: tabs, defaultTabId: "sample-submissions" }),
            isContactDyneOpen && React.createElement(ContactDyneModal, { onClose: () => setIsContactDyneOpen(false) }),
            isKitOrderOpen && (React.createElement("div", { className: "sprinkler-sampling-container" },
                React.createElement(KitOrderForm, { isOpen: isKitOrderOpen, onClose: () => setIsKitOrderOpen(false) }))))));
}
